export const WIS_REST_API = "WisRestApi";
export const WIS_API_PATH_BATCH = "/batch";
export const WIS_API_PATH_LIST = "/list";
export const WIS_API_PATH_DELETE = "/delete";
export const WIS_API_PATH_CREATE = "/create";
